import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import CaseTypeStage from '../../entities/caseTypeStage';
import DeadlineRule from '../../entities/deadlineRule';
import MatterStage from '../../entities/matterStage';
export function deleteCaseTypeStage(caseTypeStage: CaseTypeStage, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = caseTypeStage.id;}
const _work = workingSet();
store.getState().deadlineRules.getMappingFor('triggerStageId', caseTypeStage.id).filter(deadlineRuleTemp => deadlineRuleTemp.status !== 'D').forEach(deadlineRuleTemp => {
const _deadlineRule = ((_work.get('deadlineRule:' + deadlineRuleTemp.id) ?? deadlineRuleTemp) as DeadlineRule).clone();
_deadlineRule.status = 'U';
_deadlineRule.addedOn = newHRTimestamp();
_deadlineRule.addedBy = getCurrentUserId();
_deadlineRule.importSource = targetImportSource;
_deadlineRule.importId = mergeId;
if (_deadlineRule.triggerStageId === caseTypeStage.id) {
_deadlineRule.triggerStageId = null;

}
_work.set('deadlineRule:' + _deadlineRule.id, _deadlineRule);
store.dispatch(Actions.DeadlineRuleActions.saveDeadlineRuleQueue(_deadlineRule));
});
store.getState().matterStages.getMappingFor('caseTypeStageId', caseTypeStage.id).filter(matterStageTemp => matterStageTemp.status !== 'D').forEach(matterStageTemp => {
const _matterStage = ((_work.get('matterStage:' + matterStageTemp.id) ?? matterStageTemp) as MatterStage).clone();
_matterStage.status = 'U';
_matterStage.addedOn = newHRTimestamp();
_matterStage.addedBy = getCurrentUserId();
_matterStage.importSource = targetImportSource;
_matterStage.importId = mergeId;
if (_matterStage.caseTypeStageId === caseTypeStage.id) {
_matterStage.caseTypeStageId = null;

}
_work.set('matterStage:' + _matterStage.id, _matterStage);
store.dispatch(Actions.MatterStageActions.saveMatterStageQueue(_matterStage));
});



caseTypeStage.status = 'D';
caseTypeStage.addedOn = newHRTimestamp();
caseTypeStage.addedBy = getCurrentUserId();
caseTypeStage.importSource = targetImportSource;
caseTypeStage.importId = mergeId;
store.dispatch(Actions.CaseTypeStageActions.removeCaseTypeStageQueue(caseTypeStage));
}
export function replaceCaseTypeStage(caseTypeStage: CaseTypeStage, replaceWith: CaseTypeStage, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = caseTypeStage.id;}
const _work = workingSet();
store.getState().deadlineRules.getMappingFor('triggerStageId', caseTypeStage.id).filter(deadlineRuleTemp => deadlineRuleTemp.status !== 'D').forEach(deadlineRuleTemp => {
const _deadlineRule = ((_work.get('deadlineRule:' + deadlineRuleTemp.id) ?? deadlineRuleTemp) as DeadlineRule).clone();
_deadlineRule.status = 'U';
_deadlineRule.addedOn = newHRTimestamp();
_deadlineRule.addedBy = getCurrentUserId();
_deadlineRule.importSource = targetImportSource;
_deadlineRule.importId = mergeId;
if (_deadlineRule.triggerStageId === caseTypeStage.id) {
_deadlineRule.triggerStageId = replaceWith.id;

}
_work.set('deadlineRule:' + _deadlineRule.id, _deadlineRule);
store.dispatch(Actions.DeadlineRuleActions.saveDeadlineRuleQueue(_deadlineRule));
});
store.getState().matterStages.getMappingFor('caseTypeStageId', caseTypeStage.id).filter(matterStageTemp => matterStageTemp.status !== 'D').forEach(matterStageTemp => {
const _matterStage = ((_work.get('matterStage:' + matterStageTemp.id) ?? matterStageTemp) as MatterStage).clone();
_matterStage.status = 'U';
_matterStage.addedOn = newHRTimestamp();
_matterStage.addedBy = getCurrentUserId();
_matterStage.importSource = targetImportSource;
_matterStage.importId = mergeId;
if (_matterStage.caseTypeStageId === caseTypeStage.id) {
_matterStage.caseTypeStageId = replaceWith.id;

}
_work.set('matterStage:' + _matterStage.id, _matterStage);
store.dispatch(Actions.MatterStageActions.saveMatterStageQueue(_matterStage));
});



return caseTypeStage;
}
export function deleteImpactCaseTypeStage(caseTypeStage: CaseTypeStage) {
const impacts: string[] = [];
const state = store.getState();
const deadlineRuleTriggerStageIdImpact = state.deadlineRules.getMappingFor('triggerStageId', caseTypeStage.id).filter(deadlineRule => deadlineRule.status !== 'D');
deadlineRuleTriggerStageIdImpact.forEach(() => impacts.push('deadlineRules'));
const matterStageCaseTypeStageIdImpact = state.matterStages.getMappingFor('caseTypeStageId', caseTypeStage.id).filter(matterStage => matterStage.status !== 'D');
matterStageCaseTypeStageIdImpact.forEach(() => impacts.push('matterStages'));



return util.countDistinct(impacts);
}
